/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address1 } from './Address1';
import {
    Address1FromJSON,
    Address1FromJSONTyped,
    Address1ToJSON,
    Address1ToJSONTyped,
} from './Address1';

/**
 * Billing contact information returned in booking responses. All fields are optional.
 * @export
 * @interface BillingContactDisplay
 */
export interface BillingContactDisplay {
    /**
     * First/given name of the payment type account holder.
     * @type {string}
     * @memberof BillingContactDisplay
     */
    givenName?: string;
    /**
     * Last/family name of the payment type account holder.
     * @type {string}
     * @memberof BillingContactDisplay
     */
    familyName?: string;
    /**
     * 
     * @type {Address1}
     * @memberof BillingContactDisplay
     */
    address?: Address1;
}

/**
 * Check if a given object implements the BillingContactDisplay interface.
 */
export function instanceOfBillingContactDisplay(value: object): value is BillingContactDisplay {
    return true;
}

export function BillingContactDisplayFromJSON(json: any): BillingContactDisplay {
    return BillingContactDisplayFromJSONTyped(json, false);
}

export function BillingContactDisplayFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingContactDisplay {
    if (json == null) {
        return json;
    }
    return {
        
        'givenName': json['given_name'] == null ? undefined : json['given_name'],
        'familyName': json['family_name'] == null ? undefined : json['family_name'],
        'address': json['address'] == null ? undefined : Address1FromJSON(json['address']),
    };
}

export function BillingContactDisplayToJSON(json: any): BillingContactDisplay {
    return BillingContactDisplayToJSONTyped(json, false);
}

export function BillingContactDisplayToJSONTyped(value?: BillingContactDisplay | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'given_name': value['givenName'],
        'family_name': value['familyName'],
        'address': Address1ToJSON(value['address']),
    };
}

